/**
 * Joins class names, dropping the empty and undefined ones.
 *
 * The dropping is the point: interpolating an absent className into a template
 * literal renders `class="… undefined"` on the element.
 */
export function classNames(...classes: (string | false | null | undefined)[]) {
  return classes.filter(Boolean).join(' ');
}
